import { styled } from "@mui/material";

export const WrapperStorybookContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.custom.grey.light,
  padding: 20,
}));
